import React, {useState} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Menu from '@material-ui/core/Menu';
import {useStyles} from './AppBarStyle'
import MenuItem from "@material-ui/core/MenuItem";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";

export default function ResultsTableAppBarComponent(data) {

    const [anchorEl, setAnchorEl] = useState(false);
    const classes = useStyles();

    const handleAccountMenuClose = () => {
        setAnchorEl(false);
    };

    const calcMenuTitle = () => {
        if (data.currentView === "Teams") {
            return "תרגילים - " + data.sessionData;
        }
        return "ראיונות - " + data.sessionData;
    };

    const renderMenu = (
        <Menu
            // TODO - talip fix this.
            anchorEl={anchorEl}
            open={anchorEl}
            onClose={handleAccountMenuClose}
            style={{direction: "rtl"}}
        >
            <MenuItem onClick={() => {
                window.location.replace(process.env.REACT_APP_BACKEND_URL + "/auth/logout");
            }}>התנתק</MenuItem>
        </Menu>
    );

    return (
        <div>
            <AppBar
                position="static"
                className={classes.appBar}
                style={{direction: "rtl"}}
            >
                <Toolbar>
                    <Typography variant="h6" className={classes.title}>
                        {calcMenuTitle()}
                    </Typography>
                </Toolbar>
            </AppBar>
            {renderMenu}
        </div>
    );
}
